module.exports = __webpack_public_path__ + "img/report_bgm.957ba77a.png";